import { render, staticRenderFns } from "./can_not_buy.vue?vue&type=template&id=3db9eb46&scoped=true&functional=true"
var script = {}
import style0 from "./can_not_buy.vue?vue&type=style&index=0&id=3db9eb46&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "3db9eb46",
  null
  
)

export default component.exports